<section *ngIf="showStaticBanner" class="static-banner text-align-center">
	<ng-content></ng-content>
	<dz-icon class="close-icon" type="times" (click)="onClose()"></dz-icon>
</section>
